const dateSortCriteria = (a: string, b: string) => {
    if (a === '--') {
        return 1;
    }
    if (b === '--') {
        return -1;
    }
    return (new Date(a).valueOf() - new Date(b).valueOf());
};

const numericSortCriteria = (a: string, b: string) => {
    const collatorComparator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    return collatorComparator.compare(a, b);
};

export {
    dateSortCriteria,
    numericSortCriteria,
};
